import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const formatINR = (n) => {
    const v = Number(n || 0);
    return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    const s = String(iso);
    const hasTime = s.length > 10 && (s.includes("T") || s.includes(" "));
    const d = new Date(s);
    if (!hasTime) {
        return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
    }
    return d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// Permissions helper — admins always have every action.
export const hasPerm = (user, module, action) => {
    if (!user) return false;
    if (user.role === "admin") return true;
    const p = (user.permissions || {})[module] || {};
    return !!p[action];
};

// India GSTIN: 2 digits (state) + 5 letters (PAN) + 4 digits + 1 letter + 1 alphanumeric + Z + 1 alphanumeric
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
export const isValidGstin = (v) => !v || GSTIN_REGEX.test(String(v).trim().toUpperCase());

export const fileUrl = (path) => `${API_BASE}/files/${path}`;

export const downloadFile = async (endpoint, filename) => {
    const res = await api.get(endpoint, { responseType: "blob" });
    const blob = new Blob([res.data], { type: res.headers["content-type"] || "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};
